// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Element from 'element-ui'
import App from './App'
import router from './router'
import store from './store'
import Clipboard from 'vue-clipboard2'
//20210312 by wyx 引入代码高亮组件log日志使用
import hljs from 'highlight.js'
//20240228 引入模型加载视图组件
import BimcloudViewModelUi from '@pkpmcloud/bimcloud-view-model-ui'
import './setViewModelInit'

import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import 'common/stylus/index.styl'
// font-awesome
import 'font-awesome/css/font-awesome.min.css'
import 'src/common/stylelib/iconfont.css'
//20210312 by wyx 引入代码高亮组件样式
import 'highlight.js/styles/atom-one-light.css'

Vue.use(Element)
Vue.config.productionTip = false
Vue.use(Clipboard)
Vue.use(BimcloudViewModelUi)

//20210312 by wyx 自定义v-highlight指令，渲染precode包裹的代码
Vue.directive('highlight', function (el) {
  let blocks = el.querySelectorAll('pre code')
  blocks.forEach((block) => {
    hljs.highlightBlock(block)
  })
})

// 全局定义$baseUrl
Vue.prototype.$baseUrl = process.env.STATIC
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js